// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".close-btn {\n  text-align: end;\n  padding: 0 1rem 0.5rem;\n}\n.close-btn .el-button {\n  min-height: 30px;\n  padding: 0 1.3rem;\n  color: #ffffff;\n  background-color: #eb5757;\n  border-radius: 7px;\n  border: none;\n}\n.close-btn .el-button:hover, .close-btn .el-button:focus {\n  background-color: #eb5757;\n  color: #ffffff;\n  border: none;\n}", ""]);
// Exports
module.exports = exports;
